const s = {
  name: "UgandanShilling",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,16c-0.5,0-1,0.5-1,1v0.8c0,0.4,0.2,0.7,0.6,0.9l1.8,0.9c1,0.5,1.7,1.5,1.7,2.7V23c0,1.7-1.3,3-3,3
			c-1.7,0-3-1.3-3-3v-1h2v1c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1v-0.8c0-0.4-0.2-0.7-0.6-0.9l-1.8-0.9c-1-0.5-1.7-1.5-1.7-2.7V17
			c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3v1h-2v-1C21,16.5,20.5,16,20,16z"/>
		<path class="st0" d="M24,26h2v-4c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v4h2v-4c0-1.7-1.3-3-3-3c-0.4,0-0.7,0.1-1,0.2V14h-2V26z"/>
		<path class="st0" d="M10,14v9c0,1.7,1.3,3,3,3s3-1.3,3-3v-9h-2v9c0,0.5-0.5,1-1,1s-1-0.5-1-1v-9H10z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UgandanShilling
};
